const user = (state = {
    openkey:[],
    selectkey:[]
}, action) => {
    switch (action.type) {
        case "changeNavOpenkey":
            return state={
                openkey:action.openkeyArr,
                selectkey:state.selectkey
            };
        case "changeNavSelectkey":
            return state={
                selectkey:action.selectArr,
                openkey:state.openkey
            };
        default:
            return state;

    }
};
export default user






// WEBPACK FOOTER //
// ./src/reducers/NavKey.js